import { FC, useEffect, useState } from "react";
import Page, { PageBody, PageHead } from "../../ui/page/page";
import { setRequest } from "../../API";
import Input from "../../ui/input/input";
import Button from "../../ui/button/button";
import Form, { FormActions, FormBody, FormCol, FormHr, FormRow } from "../../ui/form/form";
import Tile from "../../components/tile/tile";
import { useNavigate, useParams } from "react-router-dom";
import SubscriptionsStore from "../../store/subscriptionsStore";
import { observer } from "mobx-react-lite";
import Table from "../../ui/table/table";
import Status from "../../components/status/status";
import Tabs from "../../ui/tabs/tabs";
import Tab from "../../ui/tabs/tab";
import { getFormattedDate } from "../../helper";
import NotifStore from "../../store/_notifStore";

interface Props {

}

const Subscriptions_Edit_Page: FC<Props> = observer((props: Props) => {
    const { id } = useParams();
    const navigate = useNavigate();

    const [loaded, setLoaded] = useState<boolean>(false)
    const [inited, setInited] = useState<boolean>(false)
    const [tab, setTab] = useState<'purchases' | 'games'>('purchases')

    useEffect(() => {
        load()
    }, [])

    const load = () => {
        setInited(false)
        SubscriptionsStore.setEditItemError()
        setRequest({
            type: 'GET',
            url: `/subscriptions/?id=${id}`,
            success: (payload) => {
                SubscriptionsStore.setEditItemFull(payload.data)
                setLoaded(true)
                setInited(true)
            },
            error: (err) => {
                setLoaded(true)
            }
        })
    }

    const onSubmit = () => {
        setLoaded(false)
        setRequest({
            type: "POST",
            url: '/subscriptions/',
            data: {
                id: SubscriptionsStore.editItem.id,
                count: SubscriptionsStore.editItem.count,
                expire: SubscriptionsStore.editItem.expire * 1000,
            },
            success: (payload) => {
                setLoaded(true)
                SubscriptionsStore.setEditItemError()
                SubscriptionsStore.setEditItemFull(payload.data)
                NotifStore.setSuccess('Абонемент обновлён')
            },
            error: (err) => {
                setLoaded(true)
                SubscriptionsStore.setEditItemError(err?.error)
            }
        })
    }

    return (
        <Page>
            <PageHead
                title={"Абонемент"}
                info={"#" + id}
            />
            <PageBody>
                <Tile
                    className="subscriptionEdit"
                    loaded={inited}
                    loader={true}
                >
                    <Form asModule={false}>
                        <FormBody>
                            <FormRow>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"ID"}
                                        value={SubscriptionsStore.editItem.id}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"Город"}
                                        value={SubscriptionsStore.editItem.city?.name}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                            </FormRow>
                            <FormRow>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"Игрок"}
                                        value={`${SubscriptionsStore.editItem.customer?.lastName || ''} ${SubscriptionsStore.editItem.customer?.name || ''}`.trim()}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                            </FormRow>
                            <FormRow>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"E-mail"}
                                        value={SubscriptionsStore.editItem.customer?.email}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"Телефон"}
                                        value={SubscriptionsStore.editItem.customer?.phone}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                            </FormRow>
                            <FormRow>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"Тариф"}
                                        value={SubscriptionsStore.editItem.product?.name}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"Куплен"}
                                        value={getFormattedDate(SubscriptionsStore.editItem.created ? SubscriptionsStore.editItem.created * 1000 : 0, 'dd.MM.yyyy')}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                            </FormRow>
                            <FormRow>
                                <FormCol>
                                    <Input
                                        type="text"
                                        label={"Статус"}
                                        value={SubscriptionsStore.editItem.status?.text}
                                        onChange={() => { }}
                                        disabled={true}
                                    />
                                </FormCol>
                            </FormRow>
                            <FormHr />
                            <FormRow>
                                <FormCol>
                                    <Input
                                        type="number"
                                        label={"Количество"}
                                        value={SubscriptionsStore.editItem.count}
                                        error={SubscriptionsStore.editItemError.count}
                                        onChange={value => SubscriptionsStore.setEditItem('count', value)}
                                    />
                                </FormCol>
                                <FormCol>
                                    <Input
                                        type="datetime"
                                        format="dd.MM.yyyy hh:mm"
                                        label={"Дата окончания"}
                                        value={SubscriptionsStore.editItem.expire ? SubscriptionsStore.editItem.expire * 1000 : null}
                                        hourList={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19, 20, 21, 22, 23]}
                                        minuteList={[0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55]}
                                        error={SubscriptionsStore.editItemError.expire}
                                        onChange={value => SubscriptionsStore.setEditItem('expire', Math.round(value / 1000))}
                                    />
                                </FormCol>
                            </FormRow>
                        </FormBody>
                        <FormActions>
                            <Button type="primary" onClick={onSubmit} icon="check" loading={!loaded}>Сохранить</Button>
                            <Button type="secondary" onClick={() => navigate('/subscriptions')}>Отменить</Button>
                        </FormActions>
                    </Form>
                </Tile>
                <Tabs>
                    <Tab active={tab === 'purchases'} onClick={() => setTab('purchases')}>Купленные абонементы</Tab>
                    <Tab active={tab === 'games'} onClick={() => setTab('games')}>Игры по абонементу</Tab>
                </Tabs>
                <Tile
                    className="subscriptionHistory"
                    loaded={inited}
                    loader={true}
                >
                    {tab === 'purchases' &&
                        <Table
                            thead={[
                                { title: '#' },
                                { title: 'Дата' },
                                { title: 'Тариф' },
                                { title: 'Количество' },
                                { title: 'Сумма' },
                                { title: 'Статус' },
                            ]}
                            tbody={(SubscriptionsStore.editItem.purchases || []).map(item => [
                                item.id,
                                item.date,
                                item.product_name,
                                item.count,
                                item.total,
                                <Status {...item.status} />,
                            ])}
                        />
                    }
                    {tab === 'games' &&
                        <Table
                            thead={[
                                { title: '#' },
                                { title: 'Дата' },
                                { title: 'Площадка' },
                                { title: 'Количество' },
                                { title: 'Статус' },
                            ]}
                            tbody={(SubscriptionsStore.editItem.games || []).map(item => [
                                item.id,
                                item.date,
                                item.place_name,
                                item.count,
                                <Status {...item.status} />,
                            ])}
                        />
                    }
                </Tile>
            </PageBody>
        </Page>
    )
})

export default Subscriptions_Edit_Page
